import React, { useState, useEffect } from 'react';

import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { accountService, alertService } from '../_services';
import { Role } from '../_helpers';
import { Navigation, PrivateRoute, Alert, Loading } from '../_components';
import { NBReservation, Reservation, ActivateReservation, MultiDayReservation, TransferReservation, ExtendReservation, FutureReservation } from '../reservation';
import { Profile } from '../profile';
import { ReservationList } from '../profile/ReservationList';
import { Home } from '../home';
import { Admin } from '../admin';
import { LockerAdmin } from '../lockers-admin';

import { Account } from '../account/index';
import { Contact } from '../contact';
import { PaymentError } from '../paymenterror';
import i18n from '../i18n'
import LocaleContext from '../LocaleContext';

import '../styles.css';
import '../queries.css';


function App() {
    const { pathname } = useLocation();

    const [locale, setLocale] = useState(i18n.language);

    const google = window.google;

    i18n.on('languageChanged', (lng) => setLocale(i18n.language));


    useEffect(() => {

        if (accountService.configValue['useTranslations'] == 'false') {
            i18n.changeLanguage('en');
        }
        else if (localStorage.getItem('Language') != null) {
            i18n.changeLanguage(localStorage.getItem('Language'))
        }
        else {
            i18n.changeLanguage(accountService.configValue['defaultLanguage']);
        }

    }, []);

    if (accountService.configValue["maintenanceMode"] == 'true') {

        return (
            <LocaleContext.Provider value={{ locale, setLocale }}>

                <div className="app-container">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2 mt-5 mobi-marg">
                                <div className="card m-3">
                                    <br></br>
                                    <p> The application is offline for system maintenance.</p>
                                    <p> Please try again later. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </LocaleContext.Provider>
        );

    } else {

        let ReservationComponent;

        if (accountService.configValue['useNewBraunfelsMap'] == 'true') {
            ReservationComponent = NBReservation;
        } else if (accountService.configValue['multiDay'] == 'true') {
            ReservationComponent = MultiDayReservation;
        } else {
            ReservationComponent = Reservation;
        }


        return (
            <LocaleContext.Provider value={{ locale, setLocale }}>
                <div className="app-container">

                    <Navigation />

                    <div className="container-fluid">

                        <div className="row">

                            <div className="col-lg-8 offset-lg-2 mt-5">
                                <Alert />
                                <Switch>
                                    <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
                                    <PrivateRoute exact path="/" component={Home} />
                                    <PrivateRoute path="/new-reservation" component={ReservationComponent} />
                                    {
                                        accountService.configValue['useFutureReservationButton'] === 'true' &&
                                        <PrivateRoute path="/future-reservation" component={FutureReservation} />
                                    }
                                    <PrivateRoute path="/activate-reservation/:reservationId" component={ActivateReservation} />
                                    <PrivateRoute path="/transfer-reservation/:reservationId" component={TransferReservation} />
                                    <PrivateRoute path="/extend-reservation/:reservationId" component={ExtendReservation} />
                                    <PrivateRoute path="/reservations/:listType" component={ReservationList} />
                                    <PrivateRoute path="/profile" component={Profile} />
                                    <PrivateRoute path="/admin" roles={[Role.Admin]} component={Admin} />
                                    <PrivateRoute path="/lockers-admin" roles={[Role.Admin,Role.LockerAdmin]} component={LockerAdmin} />
                                    <Route path="/account" component={Account} />
                                    <Route path="/contact" component={Contact} />
                                    <Route path="/payment-error" component={PaymentError} />
                                    <Redirect from="*" to="/" />
                                </Switch>

                            </div>
                            
                        </div>

                    </div>

                </div>

            </LocaleContext.Provider>
        );

    }

}

export { App };